import axios from 'axios'

const superaccess = {
  get: (url, store) => {
    superaccess.headers(store)
    return superaccess.response(axios.get(url), store)
  },
  post: (url, store, params = {}) => {
    superaccess.headers(store)
    return superaccess.response(axios.post(url, params), store)
  },
  put: (url, store, params = {}) => {
    superaccess.headers(store)
    return superaccess.response(axios.put(url, params), store)
  },
  patch: (url, store, params = {}) => {
    superaccess.headers(store)
    return superaccess.response(axios.patch(url, params), store)
  },
  download: (url, store) => {
    superaccess.headers(store)
    return superaccess.response(axios.get(url, { responseType: 'blob' }))
  },
  response: (request, store) => {
    return new Promise((resolve, reject) => {
      superaccess.process(request, store, resolve, reject)
    })
  },
  process: (request, store, resolve, reject) => {
    request
      .then((res) => resolve(res))
      .catch((err) => {
        if (err.response !== undefined && err.response.status === 503) {
          localStorage.setItem('logged_in', false)
          localStorage.setItem('user_data', '')
          store.commit('setUserData', '')
          localStorage.setItem('token_user', '')
          store.commit('setToken', '')
          localStorage.setItem('user_email', '')
          store.commit('setUserEmail', '')
          store.commit('setStatusConnection', true)
          reject(err)
        }
        const header = (err.response) ? err.response.headers['www-authenticate'] : undefined
        if (header && header.includes('The access token') && store.getters.dataLoggedIn) {
          localStorage.setItem('logged_in', false)
          localStorage.setItem('user_data', '')
          localStorage.setItem('company', '')
          localStorage.setItem('profile', '')
          store.commit('setUserData', '')
          localStorage.setItem('token_user', '')
          store.commit('setToken', '')
          localStorage.setItem('user_email', '')
          store.commit('setUserEmail', '')
          window.location.reload()
          reject(err)
        } else {
          reject(err)
        }
      })
  },
  headers: (store) => {
    const shard = store.getters.getUserShard
    const user = store.getters.getUserData
    const token = store.getters.getUserToken
    axios.defaults.headers.common['Profile'] = shard.profile_id
    axios.defaults.headers.common['Shard'] = shard.shard
    axios.defaults.headers.common['Company'] = shard.company_id
    axios.defaults.headers.common['User'] = user.id
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }
}

export default superaccess



// WEBPACK FOOTER //
// app/javascript/src/services/superaccess.js